import { render, staticRenderFns } from "./RegionalContactsDialog.vue?vue&type=template&id=a68bc1ba&scoped=true&lang=pug"
import script from "./RegionalContactsDialog.vue?vue&type=script&lang=js"
export * from "./RegionalContactsDialog.vue?vue&type=script&lang=js"
import style0 from "./RegionalContactsDialog.vue?vue&type=style&index=0&id=a68bc1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68bc1ba",
  null
  
)

export default component.exports